import MarkAttendanceDayView from './component';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import { isMarkable } from 'data/SessionPlans/accessors';
import SessionNav from 'containers/Group/SessionNav';
import { isGrammarProGroup } from 'containers/Group/actions';

export default ({ getState }) => ({
  appBars: ({ params }) => ({
    sticky: {
      'session-nav': {
        component: SessionNav,
        props: {
          shouldShowTime: isGrammarProGroup(getState(), params.groupId),
        },
        order: 1,
      },
    },
  }),
  path: 'day(/:mode)',
  view: 'day',
  component: MarkAttendanceDayView,
  sessionNavConfig: {
    setModeOnNavigate: '',
  },
  canAccess: (props) => {
    const state = getState();
    if (! PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.ViewDayView)) {
      return false;
    }

    if (! MarkAttendanceDayView.isInMarkingRoute(props)) {
      return true;
    }

    return PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.MarkDayView);
  },
  actionButtons: {
    default: {
      Mark: {
        isPrimary: true,
        route: './edit',
        visibleWhen: ({ params }) =>
          PrivilegeChecker.hasPrivilege(getState(), Privileges.MarkAttendance.MarkDayView) &&
            isMarkable(getState(), params.groupId, params.sessionPlanId),
      },

    },
    edit: {
      Publish: {
        isPrimary: true,
        route: '../save',
      },
      Discard: {
        route: '../discard',
      },
    },
  },
  history: (props) => {
    const { params, buildRoute } = props;
    const attendanceHistoryPath = '/group/:groupId/attendance/history';
    const link = buildRoute(attendanceHistoryPath, params);
    return { link };
  },
});



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/MarkAttendanceDayView/routes.js